const LightbulbIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    width='70'
    height='104'
    viewBox='0 0 70 104'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M0.251296 38.7259C1.78364 53.3052 12.1417 64.819 25.4588 68.5169L25.7126 70.9317L51.5701 68.214L51.2919 65.5667C63.2299 59.0699 70.7141 45.8386 69.2048 31.4786C67.2036 12.4385 50.146 -1.37553 31.1044 0.625822C12.0629 2.62717 -1.7499 19.6858 0.251296 38.7259Z'
      fill='currentColor'
    />
    <path
      d='M23.8643 73.8716L24.3178 80.3558L28.6405 80.0535L28.854 83.1064L24.5849 83.3302L24.9251 89.8213L29.3075 89.5916L29.5412 92.9341L25.2237 93.3119L25.7902 99.7871L29.9947 99.4193L30.303 103.829L51.9169 102.317L51.5822 97.5306L56.0082 97.1434L55.4416 90.6681L51.1287 91.0455L50.9478 88.4575L55.2169 88.2337L54.8767 81.7426L50.4943 81.9723L50.2544 78.5421L54.5772 78.2399L54.1238 71.7557L23.8643 73.8716Z'
      fill='currentColor'
    />
  </svg>
);

export default LightbulbIcon;
